/// <reference path="utils-customevent.ts" />
import { Utils } from './utils';
import { CustomEventUtils } from './utils-customevent';
// namespace Pacem {
export class CustomTypedEvent extends CustomEvent /* new in TypeScript v2.7.1 -> */ {
    constructor(type, detail, eventInit) {
        super(type, Utils.extend({ detail: detail }, eventInit || {}));
        CustomEventUtils.fixEdgeCustomEventSubClassInstance(this, this.constructor);
    }
}
function isEventInit(obj) {
    if ('detail' in obj) {
        // must provide a detail
        for (let prop in obj) {
            if (prop !== 'bubbles' && prop !== 'cancelable' && prop !== 'composed' && prop !== 'detail') {
                return false;
            }
        }
        return true;
    }
    return false;
}
// TODO: make inherit from CustomTypedEvent
export class CustomUIEvent extends CustomEvent {
    constructor(type, detail, eventInit, orig) {
        super(type, Utils.extend((isEventInit(detail || {}) ? detail : { detail: detail }), (!(eventInit instanceof Event) && eventInit) || {}));
        const originalEvent = orig || eventInit;
        if (originalEvent instanceof Event) {
            this.#originalEvent = originalEvent;
            this.#modifiers = CustomEventUtils.getEventKeyModifiers(originalEvent);
            if (originalEvent instanceof MouseEvent || originalEvent instanceof TouchEvent) {
                this.#coords = CustomEventUtils.getEventCoordinates(originalEvent);
            }
        }
        CustomEventUtils.fixEdgeCustomEventSubClassInstance(this, this.constructor);
    }
    #originalEvent;
    #modifiers;
    #coords;
    get originalEvent() {
        return this.#originalEvent;
    }
    get which() {
        return this.#modifiers?.which;
    }
    get altKey() {
        return this.#modifiers?.altKey;
    }
    get shiftKey() {
        return this.#modifiers?.shiftKey;
    }
    get ctrlKey() {
        return this.#modifiers?.ctrlKey;
    }
    get metaKey() {
        return this.#modifiers?.metaKey;
    }
    get pageX() {
        return this.#coords?.page.x;
    }
    get pageY() {
        return this.#coords?.page.y;
    }
    get clientX() {
        return this.#coords?.client.x;
    }
    get clientY() {
        return this.#coords?.client.y;
    }
    get screenX() {
        return this.#coords?.screen.x;
    }
    get screenY() {
        return this.#coords?.screen.y;
    }
}
export const AttributeChangeEventName = 'attributechange';
export class AttributeChangeEvent extends CustomTypedEvent {
    constructor(args) {
        super(AttributeChangeEventName, args);
    }
}
export const PropertyChangeEventName = 'propertychange';
export class PropertyChangeEvent extends CustomTypedEvent {
    constructor(args) {
        super(PropertyChangeEventName, args);
    }
}
//}
